import { PaymentMethodSelectorModule } from '../../shared/payment-method-selector/payment-method-selector.module';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../../../shared/shared.module';

import { ChargesService } from '../../../../services/charges/charges.service';
import { CheckoutService } from '../../../../services/billing/checkout.service';
import { LocalService } from '../../../../services/storage/local.service';
import { MembersService } from '../../../../services/members/members.service';
import { OrganizationService } from '../../../../services/organization/organization.service';
import { StripeService } from '../../../../services/billing/stripe.service';
import { ValidationMessageService } from '../../../../services/validation-message.service';

import { LegfiCurrencyPipe } from '../../../../pipes/format/legfi-currency.pipe';
import { LegfiCurrencyPipeModule } from '../../../../pipes/format/legfi-currency.module';
import { LegfiDatePipeModule } from '../../../../pipes/format/legfi-date.module';
import { LegfiDatePipe } from '../../../../pipes/format/legfi-date.pipe';
import { NewlineToBreakPipeModule } from '../../../../pipes/format/nl2br.module';
import { NewlineToBreakPipe } from '../../../../pipes/format/nl2br.pipe';
import { ModalService } from '../../../../services/modal.service';
import { ModalModule } from '../../../shared/modal/modal.module';
import { LoadingModalModule } from '../../shared/loading-modal/loading-modal.module';

import { AutopayModule } from '../../shared/autopay/autopay.module';
import { CurrencyInputModule } from '../../../shared/currency-input/currency-input.module';
import { MakePaymentComponent } from './make-payment.component';
import { RangeSliderModule } from '../../../shared/range-slider/range-slider.module';

@NgModule({
    imports: [
        // Shared
        SharedModule,
        // Dependencies
        AutopayModule,
        CurrencyInputModule,
        LegfiCurrencyPipeModule,
        LegfiDatePipeModule,
        LoadingModalModule,
        ModalModule,
        NewlineToBreakPipeModule,
        PaymentMethodSelectorModule,
        RangeSliderModule,
        // Routing
        RouterModule.forChild([
            {
                path: '',
                component: MakePaymentComponent,
            },
        ]),
    ],
    declarations: [MakePaymentComponent],
    providers: [
        // Services
        ChargesService,
        CheckoutService,
        LocalService,
        MembersService,
        OrganizationService,
        StripeService,
        ValidationMessageService,
        // Pipes
        LegfiCurrencyPipe,
        LegfiDatePipe,
        NewlineToBreakPipe,
        ModalService,
    ],
})
export class MakePaymentModule
{
}
